module.exports = __webpack_public_path__ + "encs/web_store/avpv/img/wps-empty-selected.33735586.svg";